import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ChevronRight, ShieldCheck, HelpCircle } from 'lucide-react';

const insuranceList = [
  'Medicare', 'Medicaid / Medi-Cal', 'Blue Cross Blue Shield', 'Aetna',
  'Cigna', 'UnitedHealthcare', 'Humana', 'Kaiser Permanente',
  'Health Net', 'Anthem', 'Molina Healthcare', 'LA Care',
  'Tricare', 'Workers\' Compensation', 'And Many More…'
];

function Insurances() {
  return (
    <main>
      {/* ===== PAGE HEADER ===== */}
      <section className="page-header">
        <div className="container">
          <div className="section-label" style={{ justifyContent: 'center' }}>Coverage</div>
          <h1 className="section-title fade-in">Insurance & Billing</h1>
          <p className="section-subtitle fade-in fade-in-delay-1" style={{ margin: '0 auto' }}>
            We accept most major insurance plans and work to make diagnostic
            imaging accessible and affordable for every patient.
          </p>
        </div>
      </section>

      {/* ===== INSURANCE INFO ===== */}
      <section className="insurance-section" style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="insurance-card">
            <div style={{ marginBottom: '48px' }}>
              <div style={{
                width: '72px', height: '72px',
                background: 'var(--blue-glow)',
                borderRadius: '20px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 24px'
              }}>
                <ShieldCheck size={32} style={{ color: 'var(--blue-primary)' }} />
              </div>
              <h2 className="section-title" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)' }}>
                We Accept Most Major Insurances
              </h2>
              <p className="section-subtitle" style={{ margin: '0 auto' }}>
                We use the "Enroll as We Go" method for insurance carriers, making
                it easy to work with a wide range of plans. If you're unsure whether
                we accept your insurance, give us a call.
              </p>
            </div>

            <div className="insurance-grid">
              {insuranceList.map((name, i) => (
                <span key={i} className="insurance-tag">{name}</span>
              ))}
            </div>

            <div style={{
              marginTop: '48px',
              padding: '28px',
              background: 'var(--bg-secondary)',
              borderRadius: '20px',
              border: '1px solid var(--border-light)',
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <HelpCircle size={24} style={{ color: 'var(--blue-primary)', flexShrink: 0 }} />
              <p style={{ fontSize: '1rem', color: 'var(--text-secondary)', margin: 0 }}>
                Not sure if we accept your insurance?
              </p>
              <a href="tel:8186265240" className="btn btn-primary" style={{ padding: '10px 24px', fontSize: '0.9rem' }}>
                <Phone size={16} /> Call (818) 626-5240
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="section-label">Get Started</div>
            <h2 className="section-title">Ready to Schedule an Exam?</h2>
            <p className="section-subtitle">
              Our team handles insurance verification so you can focus on patient care.
              Order an exam online or reach out directly.
            </p>
            <div className="cta-actions">
              <Link to="/contact" className="btn cta-btn-dark">
                Order Exam Online <ChevronRight size={18} />
              </Link>
              <a href="tel:8186265240" className="btn cta-btn-light">
                <Phone size={18} /> (818) 626-5240
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Insurances;
